// Human-readable summary of a cart/order line's options and personalization
export function describeLine(item) {
  const opts = (item?.selections || []).map(s => `${s.name}: ${s.value}`);
  const pers = (item?.personalization || []).map(p => `${p.label}: "${p.value}"`);
  return [...opts, ...pers].join(' · ');
}

// Products with options or required personalization must be configured on the product page
export function needsChoices(product) {
  return (product?.options || []).length > 0 || (product?.personalizations || []).some(f => f.required);
}

// Price a shopper pays right now, and the "was" price to strike through (sale beats compare-at)
export function displayPrice(product) {
  const now = product?.sale?.price ?? product?.price ?? 0;
  const was = product?.sale ? product.price : product?.compare_price;
  const pct = was && was > now ? Math.round((1 - now / was) * 100) : null;
  return { now, was: was && was > now ? was : null, pct };
}
